import { GET_DLM_WISE_BANK_DEPOSIT_REPORT } from '../../../Types'
import _ from 'lodash'



const DLMWiseBankDepositReportReducer = (state = [], action) => {
  switch (action.type) {
    case GET_DLM_WISE_BANK_DEPOSIT_REPORT:
  return {
    ...state,
    data: action.payload?.data || [],          // Make sure this exists
    totalRecords: action.payload?.totalRecords || 0, // And this exists
  };
    default:
      return state
  }
}
export default DLMWiseBankDepositReportReducer